import ApiService from "@/core/services/ApiService";
import { Actions, ActionsConfigs, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { PostRegisterModel } from "@/store/model/DataForm";

export interface DataFormData {
  errors: Array<string>;
  post_register: PostRegisterModel;
  listData: Array<PostRegisterModel>;
  totalPages: number;
  totalDocs: number;
  totalPending: number;
}
@Module
export default class PostRegisterModule extends VuexModule implements DataFormData {
  errors = [];
  post_register = {} as PostRegisterModel;
  listData = [];
  totalPages = 0;
  totalDocs = 0;
  totalPending = 0;

  get getTotalDataForms(): number {
    return this.totalDocs;
  }
  get getTotalPendingDataForms(): number {
    return this.totalPending;
  }
  get getDataFormPages(): number {
    return this.totalPages;
  }
  get getDataFormErrors(): Array<string> {
    return this.errors;
  }
  get listDataDataForms(): Array<PostRegisterModel> {
    return this.listData;
  }
  get currentDataForm(): PostRegisterModel {
    return this.post_register;
  }
  @Mutation
  [Mutations.SET_ERROR_POST_REGISTER](error) {
    this.errors = error;
  }
  @Mutation
  [Mutations.SET_TOTAL_PENDING_POST_REGISTER](totalPending) {
    this.totalPending = totalPending;
  }
  @Mutation
  [Mutations.SET_CURRENT_POST_REGISTER](data) {
    this.post_register = data;
  }
  @Mutation
  [Mutations.SET_ALL_POST_REGISTER_DATA](data) {
    this.listData = data.data;
    this.totalDocs = data.totalDocs;
    this.totalPages = data.totalPages;
  }
  @Action
  [ActionsConfigs.GET_ALL_POST_REGISTER](params) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setAdminPermission();
      ApiService.get("post-register", params)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ALL_POST_REGISTER_DATA, data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(
            Mutations.SET_ERROR_POST_REGISTER,
            response.data.message
          );
          reject();
        });
    });
  }
  @Action
  [ActionsConfigs.GET_TOTAL_PENDING_POST_REGISTER](params) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setAdminPermission();
      ApiService.get("post-register", params)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_TOTAL_PENDING_POST_REGISTER, data.totalDocs);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(
            Mutations.SET_ERROR_POST_REGISTER,
            response.data.message
          );
          reject();
        });
    });
  }

  @Action
  [ActionsConfigs.GET_POST_REGISTER_DETAIL](id) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setAdminPermission();
      ApiService.get("post-register/show", id)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CURRENT_POST_REGISTER, data.data);
          resolve();
          return data.data;
        })
        .catch(({ response }) => {
          this.context.commit(
            Mutations.SET_ERROR_POST_REGISTER,
            response.data.message
          );
          reject();
        });
    });
  }

  @Action
  [ActionsConfigs.UPDATE_POST_REGISTER](payload) {
    ApiService.setHeader();
    return new Promise<void>((resolve, reject) => {
      ApiService.put("post-register/update-status", payload)
        .then(({ data }) => {
          // this.context.commit("SET_CURRENT_POST_REGISTER", data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR_POST_REGISTER, response.data.message);
          reject();
        });
    });
  }

  @Action
  [ActionsConfigs.DELETE_POST_REGISTER](payload) {
    ApiService.setHeader();
    return new Promise<void>((resolve, reject) => {
      ApiService.delete("post-register/delete/" + payload.id)
        .then(() => {
          this.context.dispatch(ActionsConfigs.GET_ALL_POST_REGISTER, payload.searchString);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit("SET_POST_REGISTER_ERROR", response.data.errors);
          reject();
        });
    });
  }
}
